import { useStore } from "../../config/store";

export const clearAll = () => {
    useStore.setState({
        editOrder: null,
    });
};
